module.exports = __webpack_public_path__ + "img/idea_img3.722a1e68.png";